export const MANUSCRIPT_COMPILER_OPTIONS = [
    { value: "pdflatex", label: "pdfLaTeX" },
    { value: "xelatex", label: "XeLaTeX" },
    { value: "lualatex", label: "LuaLaTeX" },
];

export function getManuscriptCompilerLabel(value) {
    return MANUSCRIPT_COMPILER_OPTIONS.find((option) => option.value === value)?.label || value || "-";
}
